export const LOCKEDON_EMAIL_TEMPLATE = {
  to: 'support@lockedon.com',
  cc: 'help@snug.com',
  subject: 'Enable Snug as Upload Destination - Agency Setup',
  body: `Hello LockedOn

Could you please enable Snug as an upload destination for <Agency Name> for the LockedOn and provide the agency ID.

The authorised account representative has been cc'd for approval.

Thank you,

Snug Team`,
}
